var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17 15.5833",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 8.5C13.8495 8.5 14.1667 8.81713 14.1667 9.20833V11.3333H16.2917C16.6829 11.3333 17 11.6505 17 12.0417C17 12.4329 16.6829 12.75 16.2917 12.75H14.1667V14.875C14.1667 15.2662 13.8495 15.5833 13.4583 15.5833C13.0671 15.5833 12.75 15.2662 12.75 14.875V12.75H10.625C10.2338 12.75 9.91667 12.4329 9.91667 12.0417C9.91667 11.6505 10.2338 11.3333 10.625 11.3333H12.75V9.20833C12.75 8.81713 13.0671 8.5 13.4583 8.5Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0417 0C13.2153 0 14.1667 0.951395 14.1667 2.125V6.375C14.1667 6.7662 13.8495 7.08333 13.4583 7.08333C13.0671 7.08333 12.75 6.7662 12.75 6.375V2.125C12.75 1.7338 12.4329 1.41667 12.0417 1.41667H2.125C1.7338 1.41667 1.41667 1.7338 1.41667 2.125V10.625C1.41667 11.0162 1.7338 11.3333 2.125 11.3333H7.79167C8.18287 11.3333 8.5 11.6505 8.5 12.0417C8.5 12.4329 8.18287 12.75 7.79167 12.75H2.125C0.951395 12.75 0 11.7986 0 10.625V2.125C0 0.951395 0.951395 0 2.125 0H12.0417Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55509 3.20825C7.96274 2.46493 9.05024 2.48416 9.43107 3.24145L9.46635 3.32031L11.4329 8.09534C11.7209 8.79464 11.2063 9.5625 10.45 9.5625H3.76025C2.97058 9.56229 2.45732 8.73115 2.81051 8.02478L4.40633 4.83313L4.48173 4.70447C4.89565 4.09866 5.81578 4.08274 6.24011 4.71899L6.61157 5.27584L7.51636 3.28503L7.55509 3.20825ZM7.63741 6.4421C7.29259 7.20069 6.24867 7.2854 5.78634 6.5922L5.39966 6.01253L4.33301 8.14583H9.92151L8.46749 4.61523L7.63741 6.4421Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.79e6f632ad49c7cd423f89750ce352b7.svg";
export { ForwardRef as ReactComponent };